import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import CodeableConcept from './types/CodeableConcept';
import Identifier from './types/Identifier';
import Reference from './types/Reference';

export default class AdverseEvent extends DomainResource {
    static __className = 'AdverseEvent';
    __objectStructure = {
        identifier: [Identifier],
        actuality: String, // actual | potential
        category: [CodeableConcept],
        event: CodeableConcept, // type of event
        subject: Reference, // Patient
        encounter: Reference, // Encounter during which the event occurred
        date: String, // when the event occurred
        recordedDate: String, // when the event was recorded
        seriousness: CodeableConcept,
        outcome: CodeableConcept,
        recorder: Reference, // Practitioner who recorded the event
        // First class extensions
        duration: String, // how long the incident lasted
        description: String, // narrative description of the incident
        involvedIndividualsCount: Number, // number of patients/individuals involved
        involvedStaffCount: Number, // number of staff involved
        policeInvolved: Boolean, // whether police were involved
        hospitalization: Boolean, // whether hospitalization was required
        typeOfIncident: [String], // one or more incident type classifications
        followUpActions: String, // general follow up actions/recommendations
        personSpecificDetails: String, // participant-level incident details
        personSpecificFollowUp: String, // participant-level follow up actions
        notifiedWho: String, // who was notified about the incident
        notifiedWhen: String, // when the notification was made
        notifiedBy: String, // who made the notification
        furtherAction: String, // any follow-up actions taken or planned
    };

    constructor(constructJson, className = 'AdverseEvent') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
